module.exports = __webpack_public_path__ + "img/loading.12a27452.gif";